module.exports = __webpack_public_path__ + "static/img/heading-forest.226c26f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heading-forest.svg
// module id = epoP
// module chunks = 1